<table>
  <tr>
    <td style="font-size: 2em;">
      <b>Data Management Application</b>
    </td>
  </tr>
  <tr>
    <td style="font-size: 2em; text-decoration: underline;">Access Denied</td>
  </tr>
  <tr>
    <td style="font-size: 1.1em">
      Please contact <b>Santos IS</b> for support
    </td>
  </tr>
  <tr>
    <td style="font-size: 0.8em">
      <i>{{ adalErrorDescription }}</i>
    </td>
  </tr>
  <tr>
    <td>
      <a (click)="goToLoginPage()">
        <button
          class="mb-2"
          kendoButton
          [icon]="'hyperlink-open'"
          [look]="'outline'"
          style="color:white;"
        >
          Retry login
        </button>
      </a>
      <p style="font-size:0.7em;">
        {{ globals.version }}
      </p>
    </td>
  </tr>
</table>
